/**
 * @param {File} file
 */
export function fileReadNotTextTemplate(file) {
 return `No se recuperó texto al leer el archivo ${file.name}.`
}